import angular from 'angular';

import EventGroupComponent from './event-group.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-dashboard.component.event-group', [])
    .component(EventGroupComponent.selector, EventGroupComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-dashboard/component/event-group/index.js